import React from 'react'
import experience from '../../assets/Images/experience.png'
import CountUp from 'react-countup';

function ExperienceContent() {
    return (
        <div className='container'>
            <div className="row">
                <div className="col-lg-6 col-md-6 d-flex justify-content-center">   {/*  data-aos="zoom-in" data-aos-easing="ease" data-aos-duration="1500" */}
                    <div className="about-mask">
                        <figure>
                            <img src={experience} alt="experience.img" />
                        </figure>
                    </div>
                    <div className="experties d-flex align-items-center justify-content-center gap-4">
                        <hr />
                        <h5>Our Experties</h5>
                    </div>
                </div>
                <div className="col-lg-6 col-md-6 d-flex align-items-center flex-column gap-4">
                    <div className="exper-card d-flex align-items-center gap-4">
                        <div className="circle d-flex align-items-center justify-content-center">
                            <h3><CountUp start ={0} end ={90} duration ={5} delay ={2} /></h3>
                            <h3>%</h3>
                        </div>
                        <div className='exper-text'>
                            <h3>Creative Approach</h3>
                            <p>Fresh ideas tailored to your vision, ensuring your content stands out and captivates your audience.</p>
                        </div>
                    </div>  {/*data-aos="fade-down" data-aos-easing="ease" data-aos-duration="1700"*/}
                    <div className="exper-card d-flex align-items-center gap-4">
                        <div className="circle d-flex align-items-center justify-content-center">
                            <h3><CountUp start ={0} end ={99} duration ={5} delay ={2} /></h3>
                            <h3>%</h3>
                        </div>
                        <div className='exper-text'>
                            <h3>Guranteed Success</h3>
                            <p>Proven strategies and expert execution that guarantee remarkable results and client satisfaction.</p>
                        </div>
                    </div>  {/*data-aos="fade-down" data-aos-easing="ease" data-aos-duration="1700"*/}
                    <div className="exper-card d-flex align-items-center gap-4">
                        <div className="circle d-flex align-items-center justify-content-center">
                            <h3><CountUp start ={0} end ={85} duration ={5} delay ={2} /></h3>
                            <h3>%</h3>
                        </div>
                        <div className='exper-text'>
                            <h3>Brand Stategy</h3>
                            <p>Comprehensive brand strategies that build a lasting and strong impact relationships with your target audience.</p>
                        </div>
                    </div>  {/*data-aos="fade-down" data-aos-easing="ease" data-aos-duration="1700"*/}
                </div>
            </div>
        </div>
    )
}

export default ExperienceContent
